<template>
  <v-dialog
  v-model="dialog"
  width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind='attrs' v-on='on'>
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-row no-gutters class='pb-3'>
        <v-col cols='2'></v-col>
        <v-col cols='8' class='text-center pt-3'><h4>Edit Favourites</h4></v-col>
        <v-col cols='2' class='text-right'>
          <v-btn icon v-on:click="showNew=false; dialog=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-list style='max-height:300px;' class="overflow-y-auto">
        <v-list-item-group>
          <v-list-item
          v-for='lk in lineKeys' :key='lk.line_key_id'>
            <v-list-item-content>
              <v-list-item-title v-text="lk.label"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click='deleteLineKey(lk)'>
                <v-icon color='red'>mdi-close-circle</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <div class='px-3 pb-3'>
        <template v-if="addExtension">
          <v-row no-gutters>
            <v-col cols='10'>
              <v-select id="linekey-user_service_id" label="Extension" v-model="newExt" :return-object=' item => item.user_service_id' :item-text='item => item.extension + " " + (item.nickname ? item.nickname : "")' :items='extensions' ></v-select>
            </v-col>
            <v-col class='text-right'>
              <v-btn icon class='mt-4' style='margin-right:21px;' v-on:click="addLineKey"><v-icon color='primary'>mdi-plus-circle</v-icon></v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-if="addCustomNumber">
          <v-row no-gutters>
            <v-col cols='5'>
              <v-text-field label="Name" v-model="customNewLabel" class='mr-3'></v-text-field>
            </v-col>
            <v-col cols='5'>
              <v-text-field label="Number" v-model="customNewNumber" class='mr-3'></v-text-field>
            </v-col>
            <v-col class='text-right'>
              <v-btn class='mt-4' style='margin-right:21px;' icon v-on:click="addCustomLineKey(customNewLabel,customNewNumber)"><v-icon color='primary'>mdi-plus-circle</v-icon></v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-if="addPark">
          <v-row no-gutters>
            <v-col cols='10'>
              <v-select v-model="newPark" label='Park' :items='parks.map(n => n + 701)'></v-select>
            </v-col>
            <v-col class='text-right'>
              <v-btn class='mt-4' style='margin-right:21px;' icon v-on:click="addParkLineKey('Park ' + newPark,newPark)"><v-icon color='primary'>mdi-plus-circle</v-icon></v-btn>
            </v-col>
          </v-row>
        </template>
        <div>
          <v-btn small :dark='addExtension' outlined v-on:click="showKeyType('extension');" v-bind:class="addExtBtnClass">Extension</v-btn>&nbsp;
          <v-btn small :dark='addCustomNumber' outlined v-on:click="showKeyType('custom');" v-bind:class="addCustomBtnClass">Custom number</v-btn>&nbsp;
          <v-btn small :dark='addPark' outlined v-on:click="showKeyType('park');" v-bind:class="addParkBtnClass">Park</v-btn>&nbsp;
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script >
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import Api from '../api.js';
import Vue from 'vue';

export default {
  data: function() {
    return {
      showNew: false,
      addExtension: true,
      addCustomNumber: false,
      addPark: false,
      extensions: [],
      // parks: [],
      newExt: {},
      newPark: {},
      customNewLabel: '',
      customNewNumber: '',
      parks: Array.apply(null, {length: 30}).map(Function.call, Number),
      dialog: false,
    }
  },
  methods: {
    updateLineKeys: function() {
      for (let c=0;c<this.lineKeys.length;c++) {
        this.lineKeys[c].ordering = c+1;
      }
      this.$http.post(
        global.apiurl + "/device/updatelinekeys",
          {
            c2cToken: encodeURIComponent(this.device.click2call_token),
            deviceId: this.device.device_id,
            lineKeys: this.lineKeys
          }
      ).then(() => {
        // finished
        // console.log(response);
      });
    },
    deleteLineKey: async function(lk) {
      const self = this;
      let api = new Api(global.gqlClient());
      
      let lineKeys = await api.deleteLineKey(lk, this.device);
      console.log(lineKeys);
      Vue.set(self, 'lineKeys',lineKeys);
    },
    getLinekeys: function() {
      this.$http.get(
        global.apiurl + "/device/linekeys" +
          "&c2cToken=" + encodeURIComponent(this.device.click2call_token) +
          "&deviceId=" + this.device.device_id
      ).then(response => {
        this.lineKeys = response.data.data;
      });
    },
    getExtensions: function() {
      const self = this;

      this.$http.get(
        global.apiurl + "/device/extensionsforlinekey" +
          "&c2cToken=" + encodeURIComponent(self.device.click2call_token)
      ).then(response => {
        this.extensions = response.data.data;
      });
    },
    addLineKey: async function(label) {
      let self = this;

      let api = new Api(global.gqlClient());
      let lineKey = await api.addLineKey(label, this.newExt.user_service_id, this.newPickup, 'Y', this.newMonitor, this.device.device_id, this.device.click2call_token);
      if (lineKey) {
        //self.$dialog.alert('Lin');
        self.lineKeys.push(lineKey);
        self.showNew = false;
        self.$store.commit('lineKeys', self.lineKeys);
      } else {
        self.$dialog.alert('Favourite not created: ' + data.message);
      }
    },
    addCustomLineKey: async function(label, number) {
        let self = this;
        // console.log(label);
        let api = new Api(global.gqlClient());
        let lineKey = await api.addCustomLineKey(label, number, this.device.device_id, this.device.click2call_token )
        
        if (lineKey) {
          self.lineKeys.push(lineKey);
          self.showNew = false;
          self.$store.commit('lineKeys', self.lineKeys);
        } else {
          self.$dialog.alert('Favourite not created: ' + data.message);
        }
    },
    addParkLineKey: function(label, number) {
        let self = this;
        // console.log(label);
        if (label) {
          let data = {
            override: 'Y',
            pickup: 'N',
            subscribe: 'Y',
            monitor: 'N',
            overrideLabel: label,
            overrideNumber: number,
            deviceId: this.device.device_id,
            c2cToken: encodeURIComponent(this.device.click2call_token),
          };
          // console.log(data);
          this.$http.post(
            global.apiurl + '/device/addlinekey',
            data
          ).then( response => {
            // console.log(response)
            let data = response.data;
            if (data.message == "ok") {
              //self.$dialog.alert('Lin');
              let lineKey = data.lineKey;
              self.lineKeys.push(lineKey);
              self.$store.commit('lineKeys', self.lineKeys);
              self.showNew = false;
            } else {
              self.$dialog.alert('Favourite not created: ' + data.message);
            }
          });
        }
    },
    closeLineKeys: function() {
      this.$emit('closeLineKeys');
    },
    openVoicemailSettings: function(mailbox) {
      // console.log(mailbox);
      this.selectedMailbox = mailbox;
      this.showAllVoicemails = !this.showAllVoicemails;
    },
    showKeyType: function (type) {
      if (type === 'park') {
        this.addExtension = false;
        this.addCustomNumber = false;
        this.addPark = true;
        this.addSchedule = false;
      } else if (type === 'extension') {
        this.addExtension = true;
        this.addCustomNumber = false;
        this.addPark = false;
        this.addSchedule = false;
      } else if (type === 'schedule') {
        this.addExtension = false;
        this.addCustomNumber = false;
        this.addPark = false;
        this.addSchedule = true;
      } else if (type === 'custom') {
        this.addExtension = false;
        this.addCustomNumber = true;
        this.addPark = false;
        this.addSchedule = false;
      }
    },
    objectToGet: function(obj) {
      var str = "";
      for (var key in obj) {
          if (str != "") {
              str += "&";
          }
          str += key + "=" + encodeURIComponent(obj[key]);
      }
      return str;
    },
  },
  mounted() {
    this.getLinekeys();
    this.getExtensions();
  },
  components: {
    // 'app-voicemail-mailbox-settings': VoicemailMailboxSettings,
    'draggable': draggable,
  },
  props: {
    click2call: String,
  },
  computed: {
    ...mapState(['devices', 'device']),
    addExtBtnClass: function () {
      let data = { btn: true, 'btn-sm': true };
      if (this.addExtension) {
        data['primary'] = true;
      } else {
        data['btn-default'] = true;
      }
      return data;
    },
    addCustomBtnClass: function () {
      let data = { btn: true, 'btn-sm': true, };
      if (this.addCustomNumber) {
        // data['btn-info'] = true;
        data['primary'] = true;
      }
      return data;
    },
    addParkBtnClass: function () {
      let data = { btn: true, 'btn-sm': true };
      if (this.addPark) {
        // data['btn-info'] = true;
        data['primary'] = true;
      }
      return data;
    },
    lineKeys: {
      get() { return this.$store.state.lineKeys },
      set: function(v) { this.$store.commit('lineKeys',v)}
    },
  },
}
</script>
